import { UseMutationOptions, useQueryClient } from 'react-query';
import produce from 'immer';
import {
  DeleteClientPageMappingMutation,
  DeleteClientPageMappingMutationVariables,
  GetClientPageMappingsQuery,
  GetClientPageMappingsQueryVariables,
  useGetClientPageMappingsQuery,
} from 'api';

type Mutation = DeleteClientPageMappingMutation;
type MutationVariables = DeleteClientPageMappingMutationVariables;
type QueryData = GetClientPageMappingsQuery;
type QueryDataVariables = GetClientPageMappingsQueryVariables;

const useDeleteClientPageMapping = (id: QueryDataVariables) => {
  const queryClient = useQueryClient();
  const queryKey = useGetClientPageMappingsQuery.getKey(id);

  const mutationOptions: UseMutationOptions<Mutation, unknown, MutationVariables> = {
    onMutate: async ({ linkedin_page_id }) => {
      await queryClient.cancelQueries(queryKey);

      const baseState = queryClient.getQueryData<QueryData>(queryKey);
      const nextState =
        baseState &&
        produce(baseState, draftState => {
          const index = draftState.getClientPageMappings.findIndex(
            mapping => mapping.linkedin_page_id === linkedin_page_id
          );
          if (index !== -1) {
            draftState.getClientPageMappings[index].active = false;
          }
        });

      if (baseState) {
        queryClient.setQueryData<QueryData>(queryKey, nextState);
      }

      return baseState;
    },
    onError: (error, mutationArgs, baseState: QueryData) => {
      if (baseState) {
        queryClient.setQueryData<QueryData>(queryKey, baseState);
      }
    },
  };

  return mutationOptions;
};

export default useDeleteClientPageMapping;
